import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "fullDate" })
export class DatePipe implements PipeTransform {
    transform(value: number): any {
        if (!value) {
            return '--';
        }

        const dateValue = new Date(value);
        const dateWithNoTimezone =  dateValue.getMonth()+1 + '/'+ dateValue.getDate() + '/'+dateValue.getFullYear();

        return dateWithNoTimezone;
    }
}